import * as angular from "angular";
import {IController, IQService} from "angular";
import * as _ from "lodash";
import {ScheduleRequestsService} from "../../../schedule/services/schedule-requests.service";

export class agentAllocationBindingSelectCtrl implements IController {

  from: any;
  to: any;
  agentType: any;
  branchIds: any;
  selectedId: any;
  onChange: Function;

  private loaded: boolean;
  private agentsSchedule: any;
  private selectedSchedule: any;
  private searchTerm: any;

  constructor(private $mdSelect, private $log, private $q: IQService, private scheduleRequestsService: ScheduleRequestsService) {
  }

  $onInit() {
    this.searchTerm = '';
  }

  $onChanges(changes) {
    if (changes.selectedId && !changes.selectedId.isFirstChange()) {
      this.selectedSchedule = _.find(this.agentsSchedule,((s) => {
        return s.agentId === this.selectedId;
      }));
    }
  };


  onOpen() {

    if(!this.loaded){
      return this.scheduleRequestsService.getAgentScheduleInstances(this.from, this.to, this.agentType, this.branchIds, true)
        .then((agentsSchedule) => {
          this.agentsSchedule = _.uniqBy(agentsSchedule, 'id');
          this.loaded = true;
        })
        .catch((error) => {
          this.$log.error('Failed to get agents', error);
        });
    } else {
      return this.$q.when();
    }
  }

  onClose() {
    this.searchTerm = '';
    this.loaded = false;
    this.onChange({schedule: this.selectedSchedule});
  }

  cancel() {
    this.$mdSelect.hide();
  }

  reset() {
    this.searchTerm = '';
    this.selectedSchedule = undefined;
  }


}

angular
  .module('bringoz.admin.agents')
  .component('agentAllocationBindingSelect', {
    require: {
      form: '^form'
    },
    bindings: {
      from: '<',
      to: '<',
      agentType: '<',
      branchIds: '<?',
      selectedId: '<',
      onChange: '&'
    },
    template: require('./agent-allocation-binding-select.html').default,
    controller: agentAllocationBindingSelectCtrl
  });
